import React from 'react';
import { render } from 'react-dom';
import { SuiThemeProvider } from '@splashthat/sui';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ModalManager } from 'common/components/TouchpointEditor/contexts/ModalManager';
import App from './components/Confirmations/App';

const queryClient = new QueryClient();

export default () => {
    // eslint-disable-next-line no-unused-expressions
    document.getElementById('react-confirmations-modal-root')?.remove();

    const reactConfirmationsModalRoot = document.createElement('div');
    reactConfirmationsModalRoot.id = 'react-confirmations-modal-root';
    reactConfirmationsModalRoot.style.position = 'relative';
    reactConfirmationsModalRoot.style.zIndex = 99999;
    document.body.appendChild(reactConfirmationsModalRoot);

    return {
        renderConfirmationsModal: ({ serverResponse, triggerTypes }) =>
            render(
                <QueryClientProvider client={queryClient}>
                    <SuiThemeProvider>
                        <ModalManager>
                            <App serverResponse={serverResponse} triggerTypes={triggerTypes} />
                        </ModalManager>
                    </SuiThemeProvider>
                </QueryClientProvider>,
                reactConfirmationsModalRoot,
            ),
    };
};
